import { __ } from "@wordpress/i18n";
import Astra_Admin_Icons from "@Common/block-icons";
import { getAction, triggerAction } from '@Utils/extensions';

const classNames = (...classes) => classes.filter(Boolean).join(" ");

const AstraIntegration = () => {

	const handlePluginActionTrigger = ( e ) => triggerAction( e );

	const getStatusClass = (value) => {
		if (value === "activated") {
			return "text-[#4AB866] pointer-events-none";
		} else {
			return "text-astra bg-slate-50 px-[0.8125rem]";
		}
	};

	const renderBlockCards = astra_admin.integrations.map((plugin, index) => {
		return (
			<div
				key={index}
				className={classNames(
					plugin.isPro ? "bg-slate-50" : "bg-white",
					"box-border relative border rounded-md px-5 py-4 flex items-start gap-x-4 snap-start"
				)}
			>
				<div className="flex flex-col">
					<div className="flex justify-between">
						<div>
							{ plugin.logoPath.internal_icon && Astra_Admin_Icons[ plugin.logoPath.icon_path ] }
							{ ! plugin.logoPath.internal_icon && <img src={ plugin.logoPath.icon_path } width="40px" height="40px" /> }
						</div>
						<div>
							{ plugin.isPro ? (
								<span>{__('Pro', 'astra')}</span>
							) : (
								<span className="text-astra uppercase text-[0.625rem] leading-[0.0625rem] font-semibold bg-blue-50 px-1 pt-0.5 pb-[0.1875rem] rounded-[0.1875rem]">
									{__('Free', 'astra')}
								</span>
							) }
						</div>
					</div>

					<div className="mt-2">
						<div className="text-base leading-[1.625rem] font-medium text-slate-800">
							{ plugin.title }
						</div>
						<p className="text-sm leading-[1.375rem] text-slate-400 mt-[0.1875rem]">
							{ plugin.subtitle }
						</p>
						<button
							data-type="button"
							data-slug={plugin.slug}
							data-redirection={plugin.redirection}
							data-action={getAction(plugin.status)}
							data-init={plugin.path}
							onClick={ handlePluginActionTrigger }
							className={` ${getStatusClass(
								plugin.status
							)} inline-flex items-center capitalize mt-3 text-sm leading-[0.875rem] font-medium rounded-md py-[0.5625rem]`}>
							{ 'installed' == plugin.status ? astra_admin.plugin_activate_text : plugin.status }
						</button>
					</div>
				</div>
			</div>
		);
	});

	return (
		<div className="grid grid-flow-row auto-rows-min grid-cols-1 gap-4 sm:grid-cols-3 pt-6">
			{ renderBlockCards }
		</div>
	);
};

export default AstraIntegration;
